<template>
  <div>
    <unSyncMonitorUserModal ref="unSyncMonitorUserModal"></unSyncMonitorUserModal>
    <Drawer
      :title="resetPasswordModalTitle"
      v-model="resetPasswordModal"
      width="500"
      :mask-closable="true"
      @on-close="resetPasswordModalCancel">
      <div>
        <i-form ref="ResetPasswordFormItem" :model="ResetPasswordFormItem" :label-width="70" :rules="ResetPasswordRuleValidate">
          <form-item label="新密码" prop="new_password">
            <i-input type="password" v-model="ResetPasswordFormItem.new_password" placeholder=""></i-input>
          </form-item>
          <form-item label="确认密码" prop="new_password2">
            <i-input type="password" v-model="ResetPasswordFormItem.new_password2" placeholder=""></i-input>
          </form-item>
          <form-item>
            <i-button type="primary" @click="resetPasswordModalOk">提交</i-button>
            <i-button style="margin-left: 8px" @click="resetPasswordModal=false">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>
    <Card>
      <Row>
        <Col span="24" class="align-right">
          <!-- <Button style="float: right; " @click="" type="primary" :style="{marginBottom: '10px'}">同步堡垒机</Button> -->
          <div style="float: right;">
            <Button type="primary" :style="{marginBottom: '10px', marginRight: '5px'}" @click="syncModalOpen" icon="md-sync" v-show="this.$store.state.user.superuser">监控用户同步</Button>
            <Button @click="change = true" type="primary" :style="{marginBottom: '10px'}" icon="md-add" v-show="this.$store.state.user.superuser">添加用户</Button>
          </div>
        </Col>
        <Divider/>
        <Col span="24" :xl="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="50">
            <FormItem label="用户名" prop="username">
              <Input v-model="searchForm.username" placeholder="" style="min-width: 150px;"></Input>
            </FormItem>
            <FormItem label="姓名" prop="name">
              <Input v-model="searchForm.name" placeholder="" style="min-width: 150px;"></Input>
            </FormItem>
            <FormItem label="手机" prop="mobile">
              <Input v-model="searchForm.mobile" placeholder="" style="min-width: 150px;"></Input>
            </FormItem>
            <FormItem label="邮箱" prop="email">
              <Input v-model="searchForm.email" placeholder="" style="min-width: 150px;"></Input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getUsersList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px">重置</Button>
            </FormItem>
          </Form>
        </Col>
      </Row>
      <tables border :loading="tableLoading" search-place="bottom" v-model="tableData" :columns="columns"/>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getUsersList"></page>
        </div>
      </div>
      <Drawer
        title="添加用户"
        v-model="change"
        width="672"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="80" :rules="ruleValidate">
          <form-item label="用户名" prop="username">
            <i-input v-model="formItem.username" placeholder=""></i-input>
          </form-item>
          <form-item label="密码" prop="password" v-show="PassIsShow">
            <i-input type="password" v-model="formItem.password" placeholder=""></i-input>
          </form-item>
          <form-item label="姓名" prop="name">
            <i-input v-model="formItem.name" placeholder=""></i-input>
          </form-item>
          <form-item label="邮箱" prop="email">
            <i-input v-model="formItem.email" placeholder=""></i-input>
          </form-item>
          <form-item label="手机" prop="mobile">
            <i-input v-model="formItem.mobile" placeholder=""></i-input>
          </form-item>
          <form-item label="激活" prop="is_active">
            <i-switch v-model="formItem.is_active" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </form-item>
          <form-item label="超级管理员" prop="is_superuser">
            <i-switch v-model="formItem.is_superuser" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </form-item>
          <form-item label="组" prop="groups">
            <transfer
              :data="no_select_group"
              :target-keys="formItem.groups"
              :list-style="listStyle"
              @on-change="groupChange"
              filterable></transfer>
          </form-item>
          <form-item label="所属租户" prop="tenant_set">
            <transfer
              :data="tenantList"
              :target-keys="formItem.tenant_set"
              :list-style="listStyle"
              @on-change="tenantChange"
              filterable></transfer>
          </form-item>
          <!-- <form-item label="权限" prop="user_permissions">
            <transfer
              :data="no_select_permission"
              :target-keys="formItem.user_permissions"
              :list-style="listStyle"
              @on-change="permissionChange"
              filterable></transfer>
          </form-item> -->
          <form-item>
            <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
            <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import { GetUsers, ChangeUsers, DeleteUsers, getAllGroup, getAllPermission, resetPassword, userActiveApi, getAllTenants
} from '@/api/user'
import moment from 'moment'
import unSyncMonitorUserModal from '../monitor/components/un-sync-monitor-user-modal'

export default {
  name: 'account-manage',
  components: {
    Tables,
    unSyncMonitorUserModal
  },
  data () {
    return {
      tableLoading: false,
      change: false,
      count: 1,
      size: 15,
      page: 1,
      columns: [
        { type: 'selection', minWidth: 60, align: 'center' },
        { title: 'ID', key: 'id', align: 'center', minWidth: 60 },
        { title: '用户名', key: 'username', align: 'center', minWidth: 150 },
        { title: '姓名', key: 'name', align: 'center', minWidth: 100 },
        { title: '手机', key: 'mobile', align: 'center', minWidth: 100 },
        { title: '邮箱', key: 'email', align: 'center', minWidth: 180 },
        {
          title: '激活',
          key: 'is_active',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            return h('div', [
              h('i-switch', {
                props: {
                  type: 'primary',
                  size: 'small',
                  value: params.row.is_active
                },
                on: {
                  'on-change': (value) => {
                    this.activeBtn(value, params.row.id)
                  }
                }
              })
            ])
          }
        },
        {
          title: '超级管理员',
          key: 'is_superuser',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.is_superuser) {
              return h('Tag', {
                attrs: {
                  color: 'success'
                }
              }, '是')
            } else {
              return h('Tag', {
              }, '否')
            }
          }
        },
        {
          title: '创建时间',
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            if (params.row.date_joined) {
              return h('div', moment(params.row.date_joined).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '最后登录',
          align: 'center',
          minWidth: 160,
          render: (h, params) => {
            if (params.row.last_login) {
              return h('div', moment(params.row.last_login).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 200,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                  disabled: !this.$store.state.user.superuser
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.Edit(params)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: !this.$store.state.user.superuser
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.ResetPasswordFormItem.id = params.row.id
                    this.resetPasswordModal = true
                    this.resetPasswordModalTitle = '重置密码, 用户名: ' + params.row.username
                  }
                }
              }, '重置密码'),
              h('Poptip', {
                props: {
                  transfer: true,
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                on: {
                  'on-ok': () => {
                    this.handleDelete(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: !this.$store.state.user.superuser
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      formItem: {
        id: 0,
        username: '',
        password: '',
        name: '',
        mobile: '',
        email: '',
        is_active: true,
        is_staff: this.is_superuser,
        is_superuser: false,
        groups: [],
        user_permissions: [],
        tenant_set: []
      },
      searchForm: {
        username: '',
        name: '',
        mobile: '',
        email: ''
      },
      PassIsShow: true,
      no_select_group: [],
      no_select_permission: [],
      listStyle: {
        width: '230px',
        height: '300px'
      },
      ruleValidate: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur' },
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不对', trigger: 'blur' }
        ]
      },
      tenantList: [],

      // 重置密码
      resetPasswordModalLoading: true,
      resetPasswordModal: false,
      resetPasswordModalTitle: '重置密码',
      ResetPasswordFormItem: {
        id: 0,
        new_password: '',
        new_password2: ''
      },
      ResetPasswordRuleValidate: {
        new_password: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          { type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur' },
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        new_password2: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' },
          { type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur' },
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted: function () {
    this.getUsersList()
    this.getNoSelectGroup()
    this.getNoSelectPermission()
    this.getTenants()
  },
  methods: {
    Edit (params) {
      this.PassIsShow = false
      let that = this.formItem
      that.id = params.row.id
      that.username = params.row.username
      that.password = params.row.password
      that.name = params.row.name
      that.mobile = params.row.mobile
      that.email = params.row.email
      that.is_active = params.row.is_active
      that.is_staff = params.row.is_staff
      that.is_superuser = params.row.is_superuser
      that.groups = params.row.groups
      that.user_permissions = params.row.user_permissions
      that.tenant_set = params.row.tenant_set
      this.change = true
    },
    searchReset () {
      this.searchForm.username = ''
      this.searchForm.name = ''
      this.searchForm.email = ''
      this.searchForm.mobile = ''
    },
    handleSubmit (name) {
      let that = this.formItem
      that.is_staff = that.is_superuser
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          ChangeUsers(this.formItem, this.formItem.id).then(res => {
            this.$Notice.success({ title: '操作成功！' })
            that.id = 0
            that.username = ''
            that.password = ''
            that.name = ''
            that.mobile = ''
            that.email = ''
            that.is_active = true
            that.is_staff = false
            that.is_superuser = false
            that.groups = []
            that.user_permissions = []
            this.PassIsShow = true
            this.change = false
            this.getUsersList(this.page)
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
        this.changeLoadingShow = false
      })
    },
    drawerClose () {
      let that = this.formItem
      that.id = 0
      that.username = ''
      that.password = ''
      that.name = ''
      that.mobile = ''
      that.email = ''
      that.is_active = true
      that.is_staff = false
      that.is_superuser = false
      that.groups = []
      that.tenant_set = []
      that.user_permissions = []
      this.PassIsShow = true
    },
    handleDelete (params) {
      DeleteUsers(params.row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getUsersList()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    getUsersList (value = 1) {
      this.tableLoading = true
      this.page = value
      let params = {
        'size': this.size,
        'page': this.page,
        'username': this.searchForm.username,
        'name': this.searchForm.name,
        'mobile': this.searchForm.mobile,
        'email': this.searchForm.email
      }
      GetUsers(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
      })
    },
    getNoSelectGroup () {
      let that = this
      that.no_select_group = []
      getAllGroup().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_group.push({
              key: result[i].id,
              label: result[i].name
            })
          }
        }
      })
    },
    getNoSelectPermission () {
      let that = this
      that.no_select_permission = []
      getAllPermission().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_permission.push({
              key: result[i].id,
              label: result[i].name
            })
          }
        }
      })
    },
    groupChange (newTargetKeys) {
      this.formItem.groups = newTargetKeys
    },
    tenantChange (newTargetKeys) {
      this.formItem.tenant_set = newTargetKeys
    },
    permissionChange (newTargetKeys) {
      this.formItem.user_permissions = newTargetKeys
    },
    resetPasswordModalOk () {
      this.$refs['ResetPasswordFormItem'].validate((valid) => {
        if (valid) {
          if (this.ResetPasswordFormItem.new_password !== this.ResetPasswordFormItem.new_password2) {
            this.$Notice.error({ title: '两次输入的密码不同！' })
          } else {
            resetPassword(this.ResetPasswordFormItem, this.ResetPasswordFormItem.id).then(res => {
              let result = res.data
              if (result.code === 200) {
                this.ResetPasswordFormItem.id = 0
                this.ResetPasswordFormItem.new_password = ''
                this.ResetPasswordFormItem.new_password2 = ''
                this.$Notice.success({
                  title: '操作成功！'
                })
                this.resetPasswordModal = false
              } else {
                this.$Notice.error({
                  title: '操作失败！请求状态码：' + result.code,
                  desc: result.msg
                })
              }
            }).catch(res => {
              this.$Notice.error({
                title: '操作失败！ 请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
      })
    },
    resetPasswordModalCancel () {
      this.ResetPasswordFormItem.id = 0
      this.resetPasswordModalTitle = '重置密码'
    },
    activeBtn (value, id) {
      let reqData = {
        is_active: value,
        id: id
      }
      userActiveApi(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '操作成功！'
          })
          this.getUsersList(this.page)
        } else {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + result.code,
            desc: res.msg
          })
          this.getUsersList(this.page)
        }
      }).catch(errO => {
        this.$Notice.error({
          title: '操作失败！'
        })
        this.getUsersList(this.page)
      })
    },
    syncModalOpen () {
      this.$refs.unSyncMonitorUserModal.openModal()
    },
    getTenants () {
      getAllTenants().then(res => {
        let tenants = []
        const result = res.data
        for (let i in result) {
          tenants.push({
            key: result[i].id,
            label: result[i].name
          })
        }
        this.tenantList = tenants
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
